import React, {useEffect} from "react";
import {Grid, Typography} from "@mui/material";
import {getData} from "../util/__fetch";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarFilterButton,
  GridToolbarQuickFilter
} from "@mui/x-data-grid";
import {makeStyles} from "@material-ui/core";
const useStyles = makeStyles(theme => ({
  failed: {
    backgroundColor: theme.palette.error.main,
    color: 'white',
    '&:hover': { // This defines the hover style
      backgroundColor: theme.palette.error.main,
      color: 'black',
    },
  },
  actionNeeded: {
    animation: 'flashRow 1s infinite alternate', /* Adjust duration and timing function as needed */
  },
}))
const FNOLogs = ({user}) => {
  const classes = useStyles();
  const [logs, setLogs] = React.useState([]);

  function fetchLogs() {
    getData('/algo-trading/api/fno/notifications', user, setLogs, (() => {}), (() => {}))
      .then(r => {});
  }

  useEffect(() => {
    fetchLogs();
  }, [user]);

  useEffect(() => {
    const interval = setInterval(() => {
      fetchLogs()
    }, 30000);

    return () => clearInterval(interval);
  }, [user, fetchLogs]);

  const COLUMNS = [
    {
      field: 'id', headerName: 'Id', width: 100, type: 'string',
      valueGetter: (params) => {
        if (params?.row?.signalId) {
          // split string by "-" and take the first part
          return params?.row?.signalId.split('-')[0];
        }
        else {
          return params?.row?.signalId;
        }
      },
    },
    { field: 'signalId', headerName: 'Signal Id', width: 100, type: 'string',
      valueGetter: (params) => {
        if (params?.row?.signalId) {
          // split string by "-" and take the first part
          return params?.row?.signalId.split('-')[1];
        }
        else {
          return params?.row?.signalId;
        }
      },
    },
    { field: 'createdTs', headerName: 'Created At', width: 240, type: 'string', },
    { field: 'userId', headerName: 'User Id', width: 120, type: 'string', },
    { field: 'broker', headerName: 'Broker', width: 120, type: 'string', },
    { field: 'tradeStrategy', headerName: 'Strategy', width: 200, type: 'string', },
    { field: 'notificationDetails?.quantity', headerName: 'Quantity', width: 70, type: 'number',
      valueGetter: (params) => {
        return params?.row?.notificationDetails?.quantity;
      }
    },
    { field: 'notificationDetails?.price', headerName: 'Price', width: 100, type: 'number',
      valueGetter: (params) => {
        return params?.row?.notificationDetails?.price;
      }
    },
    /*{ field: 'notificationEvent', headerName: 'Event', width: 140, type: 'string', },*/
    { field: 'message', headerName: 'Message', width: 600, ttype: 'string',
      renderCell: (params) => (
        <div style={{ whiteSpace: 'normal', overflow: 'auto' }}>
          {params?.value}
        </div>
      )},
    { field: 'notificationDetails?.orderId', headerName: 'OrderId', width: 150, type: 'number',
      valueGetter: (params) => {
        return params?.row?.notificationDetails?.orderId;
      }
    },
    { field: 'status', headerName: 'Status', width: 120, type: 'string', },
  ]

  function getRowClass(status) {
    switch (status) {
      case 'FAILED':
        return classes.failed;
      case 'ACTION_NEEDED':
        return classes.actionNeeded;
      default:
        return '';
    }
  }

  return (
    <Grid container item spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h6">FNO Logs</Typography>
      </Grid>
      <Grid item xs={12}>
        <DataGrid
          getRowId={(row) => row?.signalId}
          columns={COLUMNS}
          rows={logs}
          autoHeight={true}
          initialState={{
            sorting: {
              sortModel: [{ field: 'id', sort: 'desc' }]
            },
            pagination: {
              paginationModel: { page: 0, pageSize: 50 },
            },
          }}
          pageSizeOptions={[10, 20, 50, 100, 200, 500, 1000]}
          getRowClassName={(params) => {
            return getRowClass(params?.row?.status);
          }}
          rowHeight={80}
          slots={{
            toolbar: () => <GridToolbarContainer style={{ justifyContent: 'space-around' }}>
              <Typography variant='h6' align='center'>Trade Logs</Typography>
              <>
                <GridToolbarFilterButton />
                <GridToolbarExport />
                <GridToolbarQuickFilter />
              </>
            </GridToolbarContainer>
          }}
        />
      </Grid>
    </Grid>
  );
}

export default FNOLogs;